import { Pipe, PipeTransform } from '@angular/core';
import { RelatedEntry } from '@maximizer/core/shared/domain';
import { getFontAwesomeIcon } from '../icons';

@Pipe({ name: 'relatedEntryIcon', })
export class RelatedEntryIconPipe implements PipeTransform {
  transform(entry: RelatedEntry): string {
    switch (entry?.type) {
      case 'opportunity':
        return getFontAwesomeIcon('dollar-sign', 'solid');

      case 'addressBook':
        return getFontAwesomeIcon('address-book');

      case 'case':
        return getFontAwesomeIcon('comment-question');

      case 'campaign':
        return getFontAwesomeIcon('bullhorn');

      case 'lead':
        return getFontAwesomeIcon('user-magnifying-glass');

      default:
        return '';
    }
  }
}
